(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bareway-countdown"] && !Shopify.designMode) return;
  try {
    
(()=>{const boot=()=>document.querySelectorAll('[data-bw-countdown]').forEach(root=>{
if(root.dataset.ready)return;root.dataset.ready='true';
const duration=Number(root.dataset.minutes)*60000,key='bareway_countdown_end_v1_'+root.dataset.minutes;let end=0;
try{end=Number(localStorage.getItem(key))}catch{}
function reset(){end=Date.now()+duration;try{localStorage.setItem(key,String(end))}catch{}}
if(!end||end<=Date.now()||end-Date.now()>duration)reset();
function tick(){if(!root.isConnected)return;let delta=end-Date.now();if(delta<=0){reset();delta=duration}
const total=Math.ceil(delta/1000),values={days:Math.floor(total/86400),hours:Math.floor(total/3600)%24,minutes:Math.floor(total/60)%60,seconds:total%60};
for(const [unit,value]of Object.entries(values))root.querySelector('[data-unit="'+unit+'"]').textContent=String(value).padStart(2,'0');setTimeout(tick,1000)}
tick();
});if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();document.addEventListener('shopify:section:load',boot)})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bareway-editorial-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bareway-editorial-reviews')) {
 customElements.define('bareway-editorial-reviews',class extends HTMLElement {
  connectedCallback(){this.setup=setTimeout(()=>this.init(),0)}
  init(){
   if(!this.isConnected)return;
   this.track=this.querySelector('.bwer__track');this.pause=this.querySelector('[data-pause]');
   if(!this.track||!this.pause)return;
   this.abort=new AbortController();const opts={signal:this.abort.signal};
   this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.manual=false;this.hover=false;this.visible=false;this.hold=0;
   this.delay=Math.max(4,Number(this.dataset.interval)||6)*1000;
   const hold=()=>{this.hold=Date.now()+this.delay;};
   this.move=(dir)=>{const cards=[...this.track.children];if(!cards.length)return;const step=cards.length>1?cards[1].offsetLeft-cards[0].offsetLeft:cards[0].offsetWidth;const max=this.track.scrollWidth-this.track.clientWidth;let to=this.track.scrollLeft+dir*step;if(dir>0&&this.track.scrollLeft>=max-3)to=0;if(dir<0&&this.track.scrollLeft<=3)to=max;this.track.scrollTo({left:Math.max(0,Math.min(max,to)),behavior:this.motion.matches?'instant':'smooth'});};
   this.querySelector('[data-next]').addEventListener('click',()=>{hold();this.move(1)},opts);
   this.querySelector('[data-prev]').addEventListener('click',()=>{hold();this.move(-1)},opts);
   this.pause.addEventListener('click',()=>{this.manual=!this.manual;this.pause.setAttribute('aria-pressed',String(this.manual));this.pause.textContent=this.manual?this.pause.dataset.resumeLabel:this.pause.dataset.pauseLabel;hold()},opts);
   this.pause.hidden=this.dataset.autoplay!=='true'||this.motion.matches;
   this.motion.addEventListener('change',()=>{this.pause.hidden=this.dataset.autoplay!=='true'||this.motion.matches;hold()},opts);
   this.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse')this.hover=true},opts);
   this.addEventListener('pointerleave',()=>{this.hover=false;hold()},opts);
   this.track.addEventListener('pointerdown',hold,opts);this.track.addEventListener('wheel',hold,{...opts,passive:true});this.track.addEventListener('scroll',hold,{...opts,passive:true});
   this.track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();hold();this.move(e.key==='ArrowRight'?1:-1)}},opts);
   this.addEventListener('shopify:block:select',e=>{const card=e.target.closest('.bwer__card');if(card){this.manual=true;this.pause.setAttribute('aria-pressed','true');this.pause.textContent=this.pause.dataset.resumeLabel;this.track.scrollTo({left:card.offsetLeft-this.track.children[0].offsetLeft,behavior:'instant'})}},opts);
   this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;hold()},{threshold:.2});this.observer.observe(this);
   this.timer=setInterval(()=>{if(this.dataset.autoplay==='true'&&this.dataset.editor!=='true'&&!this.manual&&!this.hover&&!this.motion.matches&&this.visible&&!document.hidden&&!this.contains(document.activeElement)&&Date.now()>=this.hold){this.move(1);hold()}},250);
  }
  disconnectedCallback(){clearTimeout(this.setup);clearInterval(this.timer);this.abort?.abort();this.observer?.disconnect()}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bareway-review-carousel"] && !Shopify.designMode) return;
  try {
    


if (!customElements.get('bareway-photo-reviews')) {
  customElements.define('bareway-photo-reviews', class extends HTMLElement {
    connectedCallback() {
      this.initTimer = setTimeout(() => this.initialize(), 0);
    }
    initialize() {
      if (!this.isConnected) return;
      this.viewport = this.querySelector('.photo-reviews__viewport');
      this.original = this.querySelector('[data-original]');
      if (!this.viewport || !this.original) return;
      this.control = this.querySelector('.photo-reviews__pause');
      this.label = this.querySelector('label');
      this.media = matchMedia('(prefers-reduced-motion: reduce)');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.hovering = false;
      this.pressing = false;
      this.visible = true;
      this.until = 0;
      this.position = 0;
      const hold = () => { this.until = performance.now() + 1800; };
      this.viewport.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') this.hovering = true; }, options);
      this.viewport.addEventListener('pointerleave', () => { this.hovering = false; }, options);
      this.viewport.addEventListener('pointerdown', () => { this.pressing = true; hold(); }, options);
      window.addEventListener('pointerup', () => { if (this.pressing) { this.pressing = false; hold(); } }, options);
      window.addEventListener('pointercancel', () => { if (this.pressing) { this.pressing = false; hold(); } }, options);
      this.viewport.addEventListener('wheel', hold, { ...options, passive: true });
      this.viewport.addEventListener('keydown', hold, options);
      this.viewport.addEventListener('scroll', () => {
        if (this.pressing || performance.now() < this.until) hold();
      }, { ...options, passive: true });
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.photo-reviews__card');
        if (card) this.viewport.scrollLeft = card.offsetLeft - this.original.offsetLeft;
      }, options);
      this.media.addEventListener('change', () => this.rebuild(), options);
      this.resize = new ResizeObserver(() => this.rebuild());
      this.resize.observe(this.viewport);
      this.resize.observe(this.original);
      this.intersection = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; });
      this.intersection.observe(this);
      this.rebuild();
      this.last = 0;
      const tick = now => {
        const delta = this.last ? Math.min(now - this.last, 50) : 0;
        this.last = now;
        const focused = this.viewport.matches(':focus-visible') || this.viewport.querySelector(':focus-visible');
        if (this.looping && !this.control.checked && !this.hovering && !this.pressing && !focused && this.visible && !document.hidden && now >= this.until) {
          if (Math.abs(this.viewport.scrollLeft - this.written) > 1) this.position = this.viewport.scrollLeft;
          const seconds = Math.max(20, Number(this.dataset.duration) || 60);
          this.position = (this.position + this.period * delta / (seconds * 1000)) % this.period;
          this.viewport.scrollLeft = this.position;
          this.written = this.viewport.scrollLeft;
        } else {
          this.position = this.viewport.scrollLeft;
          this.written = this.position;
        }
        this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    }
    rebuild() {
      const previous = this.viewport.scrollLeft;
      this.querySelectorAll('[data-copy]').forEach(copy => copy.remove());
      this.period = this.original.getBoundingClientRect().width;
      this.looping = this.dataset.autoplay === 'true' && this.dataset.editor !== 'true' && !this.media.matches && this.period > 0;
      if (this.looping) {
        const copies = Math.max(1, Math.ceil(this.viewport.clientWidth / this.period));
        for (let index = 0; index < copies; index += 1) {
        const copy = this.original.cloneNode(true);
        copy.removeAttribute('data-original');
        copy.setAttribute('data-copy', '');
        copy.setAttribute('aria-hidden', 'true');
        copy.setAttribute('inert', '');
        copy.querySelectorAll('[id], [data-shopify-editor-block]').forEach(node => {
          node.removeAttribute('id');
          node.removeAttribute('data-shopify-editor-block');
        });
        this.original.parentElement.append(copy);
        }
      }
      this.control.hidden = !this.looping;
      this.label.hidden = !this.looping;
      this.viewport.scrollLeft = this.looping ? previous % this.period : previous;
      this.position = this.viewport.scrollLeft;
      this.written = this.position;
    }
    disconnectedCallback() {
      clearTimeout(this.initTimer);
      this.abort?.abort();
      this.resize?.disconnect();
      this.intersection?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      const headerMediaQuery = window.matchMedia('(max-width: 990px)');
      const handleHeaderMediaChange = this.setHeaderHeight.bind(this);
      if (headerMediaQuery.addEventListener) {
        headerMediaQuery.addEventListener('change', handleHeaderMediaChange);
      } else if (headerMediaQuery.addListener) {
        headerMediaQuery.addListener(handleHeaderMediaChange);
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
